import { Tooltip } from "@mui/material";

interface IProps extends React.HTMLAttributes<HTMLDivElement> {
  title?: string;
  placement?: any;
  IconType: any;
  onClick?: any;
  // onClick?: () => void;
}

const CustomIcon = ({
  title,
  IconType,
  onClick,
  placement = "top",
  ...rest
}: IProps) => {
  return (
    <Tooltip title={title ? title : ""} placement={placement}>
      <img
        src={IconType}
        alt={title ? title : "logo"}
        {...rest}
        onClick={onClick}
        {...rest}
      />
    </Tooltip>
  );
};

export default CustomIcon;
